import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { Theme } from '@mui/material/styles';

export const useStyles = makeStyles((theme: Theme) => createStyles({
  polygonsSwitchWrapper: {
    display: 'inline-flex',
    gap: '10px',
    height: '44px',
    padding: '10px 16px',
    backgroundColor: '#fff',
    opacity: '.8',
    borderRadius: '5px',
    boxShadow: '0px 0px 3px 0px #d2d2d2',
    '& .root': {
      margin: '0',
    },
    [theme.breakpoints.down('md')]: {
      height: '40px',
    },
    [theme.breakpoints.down(1280)]: {
      height: '40px',
    },
    [theme.breakpoints.up('xl')]: {
      height: '56px',
    },
  },
  control: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
    [theme.breakpoints.up('xl')]: {
      height: '28px',
    },
  },
}));
